import { post } from './commonFetch';
import { TravelerRegisterInfo } from '../types/travelerRegister';

export type TravelerRegisterResponse = {
  success: boolean;
  pending: boolean;
  error: string;
};

type ApiTravelerRegisterInfo = {
  accountId: number;
  travelerKey: string;
  username: string;
  password: string;
  emailAddress: string;
  kwijybo: string;
  tripId: number;
};

const transformToApiTravelerRegisterInfo = (
  travelerRegisterInfo: TravelerRegisterInfo,
): ApiTravelerRegisterInfo => {
  return {
    accountId: travelerRegisterInfo.accountId,
    travelerKey: travelerRegisterInfo.travelerKey,
    username: travelerRegisterInfo.username,
    password: travelerRegisterInfo.password,
    emailAddress: travelerRegisterInfo.email,
    kwijybo: travelerRegisterInfo.kwijybo,
    tripId: travelerRegisterInfo.tripId,
  };
};

export const travelerRegister = (
  travelerRegisterInfo: TravelerRegisterInfo,
): Promise<TravelerRegisterResponse> =>
  post(
    '/traveler/register',
    transformToApiTravelerRegisterInfo(travelerRegisterInfo),
  );